import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Drawer, message, Typography, Avatar } from "antd";
import { MailOutlined, UserOutlined } from "@ant-design/icons";
import { Logo, ProfileIcon, WalletIcon, LogoutIcon, DashboardIcon } from "../../../assets/CustomIcon";

import { getJwtPayload } from "../../../utils/appUtils";
import TopNavbarMenu from "../Menus/TopNavbar";
import LoginNavigation from "../Menus/LoginNavigation";

const { Title } = Typography;
export default function Header({ isHome = true }) {
    const navigate = useNavigate();

    const [isMobileView, setIsMobileView] = useState(false);
    const [visible, setVisible] = useState(false);

    // User payload from JWT token
    const token = localStorage.getItem('authToken');
    const userPayload = getJwtPayload(token);

    // Mobile menu handlers
    const showDrawer = () => setVisible(true);
    const onClose = () => setVisible(false);

    const handleLogout = () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userLocation');
        message.success('Logged out successfully!');
        navigate("/login");
    };

    // Mobile view detection
    useEffect(() => {
        window.scrollTo(0, 0);
        const mediaQuery = window.matchMedia("(max-width: 991.98px)");
        const updateViewport = (event) => setIsMobileView(event.matches);

        setIsMobileView(mediaQuery.matches);
        mediaQuery.addEventListener("change", updateViewport);

        return () => mediaQuery.removeEventListener("change", updateViewport);
    }, []);

    // Handle menu item clicks
    const handleMenuClick = ({ key }) => {
      switch (key) {
        case 'dashboard':
          navigate('/dashboard');
          break;
        case 'myProfile':
          navigate('/my-profile');
          break;
        case 'myTickets':
          navigate('/my-tickets');
          break;
        case 'invitations':
          navigate('/invitation-rsvps');
          break;
        case 'logoutButton':
          handleLogout();
          break;
        default:
          break;
      }
    };

    const profileDropdown = [
      {
        key: "profileInfo",
        label: (
          <div>
            <div>{`${userPayload?.first_name || ""} ${userPayload?.last_name || ""}`.trim()}</div>
            <div>{userPayload?.email || ""}</div>
          </div>
        ),
        icon: (
            <span className="dropdownItemIcon">
                <Avatar icon={<UserOutlined />} />
            </span>
        ),
      },
      {
        type: "divider",
      },
      {
        key: "dashboard",
        label: "Dashboard",
        icon: (
        <span className="dropdownItemIcon">
            <DashboardIcon />
        </span>
        ),
      },
      {
        key: "myProfile",
        label: "My Profile",
        icon: (
          <span className="dropdownItemIcon">
            <ProfileIcon />
          </span>
        ),
      },
      {
        key: "myTickets",
        label: "My Tickets",
        icon: (
          <span className="dropdownItemIcon">
            <WalletIcon />
          </span>
        ),
      },
      {
        key: "invitations",
        label: "Invitation RSVPs",
        icon: (
          <span className="dropdownItemIcon">
            <MailOutlined />
          </span>
        ),
      },
      {
        type: "divider",
      },
      {
        key: "logoutButton",
        label: "Logout",
        danger: true,
        icon: (
          <span className="dropdownItemIcon">
            <LogoutIcon />
          </span>
        ),
      },
    ];

    const displayLoginButton = () => {
        const token = localStorage.getItem('authToken');
        if (token) {
            return (
                <LoginNavigation 
                    handleMenuClick={handleMenuClick}
                    profileDropdown={profileDropdown}
                />
            );
        }

        if (isMobileView) {
          return (
            <Button type="primary" size="large" className="headerSignupBtn loginBtnForMob" onClick={() => navigate("/signup")}>
              Sign up
            </Button>
          );
        }

        return (
          <div className="authButtonsWrap">
            <Button type="text" className="headerLoginLink" onClick={() => navigate("/login")}>
              Login
            </Button>
            <Button type="primary" size="large" className="headerSignupBtn" onClick={() => navigate("/signup")}>
              Sign up
            </Button>
          </div>
        );
    };
    
    return (
        <header className="topNavbar nabarLight">
            <div className="container">
                <nav className="authNavbarWrap homeNavbarWrap">
                    <Title level={1} style={{ margin: 0 }} title="Pingvite">
                        <Link to="/" className="siteLogo">
                            <Logo />
                        </Link>
                    </Title>
                    {/* Desktop Navigation */}
                    <div className={"deskNav" + (isHome ? "" : " authDisplayAlignment")}>
                        <TopNavbarMenu />
                    </div>
                    {displayLoginButton()}
                    {/* Mobile Menu Button */}
                    <Button
                        className="menuMobileButton btnGradient"
                        type="primary"
                        size="large"
                        onClick={showDrawer}
                    >
                        <span className="material-symbols-outlined">menu</span>
                    </Button>
                    {/* Mobile Menu Drawer */}
                    <Drawer
                        title="Menu"
                        placement="right"
                        onClose={onClose}
                        open={visible}
                        className="menuDrawer"
                    >
                        <TopNavbarMenu />
                    </Drawer>
                </nav>
            </div>
        </header>
    );
}